export const DEFAULT_CONNECT_TIMEOUT_BROWSER = 1000;
export const DEFAULT_READ_TIMEOUT_BROWSER = 2000;
export const DEFAULT_WRITE_TIMEOUT_BROWSER = 30000;

export const DEFAULT_CONNECT_TIMEOUT_NODE = 2000;
export const DEFAULT_READ_TIMEOUT_NODE = 5000;
export const DEFAULT_WRITE_TIMEOUT_NODE = 30000;
